import { Gavel, Group, Sync, ChatBubble, Settings, Feed, Timer, Directions, DriveFileRenameOutline, SupportAgent, Engineering, Reviews, SmsFailed, SmsRounded } from "@mui/icons-material";
import SysBnR from "./SysBnR/SysBnR";
import SysUser from "./SysUser/SysUser";
import SysChatbot from "./SysChatbot";
import SysNLP from "./SysNLP";
import SysGeneral from "./SysGeneral/SysGeneral";
import SysVersion from "./SysVersion";
import SysDefaultMessages from "./SysDefaultMessages";
import SysDisclaimer from "./SysDisclaimer";
import SysSpamSetting from "./SysSpamSetting";
import SysSurvey from "./SysSurvey";
import SysInputFieldSetting from "./SysInputFieldSetting";
import SysTimeout from "./SysTimeout";
import SysRedirectURL from "./SysRedirectURL";
import SysEService from "./SysEService";
import SysLiveAgent from "./SysLiveAgent";
import SysMaintenancePage from "./SysMaintenancePage";
import SysAnswerReviewSetting from "./SysAnswerReviewSetting";
import SysErrorMessage from "./SysErrorMessage";
import SysSpecialAnswer from "./SysSpecialAnswer";

const tabs = [
  {
    label: "SPAM Setting",
    icon: <i className="fas fa-exclamation-triangle fa-lg" />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysSpamSetting />,
  },
  {
    label: "Error Message",
    icon: <SmsFailed />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysErrorMessage />,
  },
  {
    label: "Special Answer",
    icon: <SmsRounded />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysSpecialAnswer />,
  },
  {
    label: "E-Service Setting",
    icon: <Feed />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysEService />,
  },
  {
    label: "Live Agent Setting",
    icon: <SupportAgent />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysLiveAgent />,
  },
  {
    label: "Input Field Setting",
    icon: <DriveFileRenameOutline />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysInputFieldSetting />,
  },
  {
    label: "Time out",
    icon: <Timer />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysTimeout />,
  },
  {
    label: "Survey Text",
    reqAuth: "System.Disclaimer",
    icon: <i className="fas fa-comment-dots fa-lg" />,
    iconPos: "left",
    noTransform: true,
    render: <SysSurvey />,
  },
  {
    label: "Redirect URL",
    reqAuth: "System.Disclaimer",
    icon: <Directions />,
    iconPos: "left",
    noTransform: true,
    render: <SysRedirectURL />,
  },
  {
    label: "Answer Review",
    reqAuth: "System.Disclaimer",
    icon: <Reviews />,
    iconPos: "left",
    noTransform: true,
    render: <SysAnswerReviewSetting />,
  },
  {
    label: "Maintenance Page",
    reqAuth: "System.Disclaimer",
    icon: <Engineering />,
    iconPos: "left",
    noTransform: true,
    render: <SysMaintenancePage />,
  },
  {
    label: "Version",
    icon: <Gavel />,
    reqAuth: "System.General",
    iconPos: "left",
    noTransform: true,
    render: <SysVersion />,
  },
  {
    label: "General",
    icon: <Settings />,
    reqAuth: "System.General",
    iconPos: "left",
    noTransform: true,
    render: <SysGeneral />,
  },
  {
    label: "Backup & Restore",
    icon: <Sync />,
    reqAuth: "System.BnR",
    render: <SysBnR />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
  },
  {
    label: "User Access Control",
    icon: <Group />,
    reqAuth: "System.User",
    render: <SysUser />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
  },
  {
    label: "NLP",
    icon: <i className="fas fa-microchip fa-lg" />,
    iconPos: "left",
    noTransform: true,
    reqAuth: "System.NLP",
    render: <SysNLP />,
  },
  {
    label: "Chatbot",
    icon: <i className="fas fa-robot fa-lg" />,
    reqAuth: "System.Chatbot",
    iconPos: "left",
    noTransform: true,
    render: <SysChatbot />,
  },
  {
    label: "Default Messages",
    icon: <i className="fas fa-comment-dots fa-lg" />,
    reqAuth: "System.DefaultMessages",
    iconPos: "left",
    noTransform: true,
    render: <SysDefaultMessages />,
  },
  {
    label: "Disclaimer",
    icon: <i className="fas fa-exclamation-triangle fa-lg" />,
    reqAuth: "System.Disclaimer",
    iconPos: "left",
    noTransform: true,
    render: <SysDisclaimer />,
  },
];

export default tabs;
